import { render, staticRenderFns } from "./AuthLoginCallback.vue?vue&type=template&id=51b2c1f6&scoped=true&"
import script from "./AuthLoginCallback.vue?vue&type=script&lang=js&"
export * from "./AuthLoginCallback.vue?vue&type=script&lang=js&"
import style0 from "./AuthLoginCallback.vue?vue&type=style&index=0&id=51b2c1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b2c1f6",
  null
  
)

export default component.exports